import { FALLBACK_STARTING_TEMPLATED_MESSAGE } from 'modules/sourcing-shared/constants';
import { createApolloClient } from 'core/services/apollo';
import { GenerateSourcingTemplateDocument } from 'generated-graphql/graphql';
import { Channels } from 'generated-graphql/types';

type GenerateSourcingTemplateInput = {
  jobDescription: string;
  jobTitle: string | null | undefined;
  employerName: string | null | undefined;
  channel: Channels;
};

export const generateSourcingTemplate = async (
  input: GenerateSourcingTemplateInput
): Promise<string> => {
  if (!input.jobDescription || !input.jobTitle || !input.employerName)
    return FALLBACK_STARTING_TEMPLATED_MESSAGE;

  const client = createApolloClient();

  const { data } = await client.mutate({
    mutation: GenerateSourcingTemplateDocument,
    variables: {
      input: {
        jobDescription: input.jobDescription,
        jobTitle: input.jobTitle,
        employerName: input.employerName,
        channel: input.channel
      }
    }
  });

  if (!data?.generateSourcingTemplate?.template)
    return FALLBACK_STARTING_TEMPLATED_MESSAGE;

  return data.generateSourcingTemplate.template;
};
